import React from 'react';
import {
	styled,
	ParentBoundComponent,
	Module
} from 'ps-gui';

import SessionLogModel from './sessionlogmodel';
import {
	CellMainText,
	CellSubText
} from './portalresultsetmodule';

const Wrapper = styled.div`
`;

export default class SessionLogModule extends ParentBoundComponent {

	getModel() {
		return new SessionLogModel(this.getData());
	}

	setModel(model) {
		this.setData(model.getData());
	}

	componentDidMount() {
		if (!this.getData().get('initialized')) {
			this.setModel(this.getModel().initialize());
		}
	}

	render() {
		const data = this.getData();
		return (
			<Wrapper>
				<Module
					appState={data.get('search')}
					onDataChange={newData => {
						this.setData(data.setIn(['search', 'data'], newData));
					}}
					customResultProps={customResultProps}
				//leftToolBar={this.renderCandidateListToolbar}
				//onResultIconMouseDown={this.onCandidateIconMouseDown}
				/>
			</Wrapper>
		);
	}
}

const cellRendererMap = Object.freeze({
	'user': (cell, row, colIndex) => {
		return (
			<>
				<CellMainText>{cell}</CellMainText>
				<CellSubText>{row.get('user_display_name')}</CellSubText>
			</>
		);
	},
	'proxy_user': (cell, row, colIndex) => {
		return (
			<>
				<CellMainText>{cell}</CellMainText>
				<CellSubText>{row.get('proxy_user_display_name')}</CellSubText>
			</>
		);
	},
});

const customResultProps = {
	cellRendererMap,
	defaultColumnWidths: {
		'session_id': '100px',
	},
	columnFilters: {
		'login_type': {
			type: 'lookup',
			lookup: 'loginType'
		},
		'session_id': {
			type: 'number',
			groupless: true,
			inputSize: 8,
		},
		'login_time': {
			type: 'date'
		},
		'logout_time': {
			type: 'date'
		},
		'last_access_time': {
			type: 'date'
		},
		user: {
			type: 'lookup',
			lookup: 'user'
		},
		proxy_user: {
			type: 'lookup',
			lookup: 'user'
		}
	}
};

